/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as ApphomeIndexRouteImport } from './routes/_app/(home)/index'
import { Route as AppplayFriendRouteImport } from './routes/_app/(play)/friend'
import { Route as AppplayQuickRouteImport } from './routes/_app/(play)/quick'
import { Route as AppGameGameIdRouteImport } from './routes/_app/game/$gameId'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppProfileHistoryRouteImport } from './routes/_app/profile/history'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ApphomeIndexRoute = ApphomeIndexRouteImport.update({
  id: '/(home)/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppplayFriendRoute = AppplayFriendRouteImport.update({
  id: '/(play)/friend',
  path: '/friend',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppplayQuickRoute = AppplayQuickRouteImport.update({
  id: '/(play)/quick',
  path: '/quick',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGameGameIdRoute = AppGameGameIdRouteImport.update({
  id: '/game/$gameId',
  path: '/game/$gameId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileHistoryRoute = AppProfileHistoryRouteImport.update({
  id: '/profile/history',
  path: '/profile/history',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ApphomeIndexRoute
  '/friend': typeof AppplayFriendRoute
  '/quick': typeof AppplayQuickRoute
  '/game/$gameId': typeof AppGameGameIdRoute
  '/profile/history': typeof AppProfileHistoryRoute
  '/profile/': typeof AppProfileIndexRoute
}
export interface FileRoutesByTo {
  '/friend': typeof AppplayFriendRoute
  '/quick': typeof AppplayQuickRoute
  '/game/$gameId': typeof AppGameGameIdRoute
  '/profile/history': typeof AppProfileHistoryRoute
  '/': typeof ApphomeIndexRoute
  '/profile': typeof AppProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_app/(play)/friend': typeof AppplayFriendRoute
  '/_app/(play)/quick': typeof AppplayQuickRoute
  '/_app/game/$gameId': typeof AppGameGameIdRoute
  '/_app/profile/history': typeof AppProfileHistoryRoute
  '/_app/(home)/': typeof ApphomeIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/friend'
    | '/quick'
    | '/game/$gameId'
    | '/profile/history'
    | '/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/friend'
    | '/quick'
    | '/game/$gameId'
    | '/profile/history'
    | '/'
    | '/profile'
  id:
    | '__root__'
    | '/_app'
    | '/_app/(play)/friend'
    | '/_app/(play)/quick'
    | '/_app/game/$gameId'
    | '/_app/profile/history'
    | '/_app/(home)/'
    | '/_app/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/(home)/': {
      id: '/_app/(home)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ApphomeIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(play)/friend': {
      id: '/_app/(play)/friend'
      path: '/friend'
      fullPath: '/friend'
      preLoaderRoute: typeof AppplayFriendRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(play)/quick': {
      id: '/_app/(play)/quick'
      path: '/quick'
      fullPath: '/quick'
      preLoaderRoute: typeof AppplayQuickRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/game/$gameId': {
      id: '/_app/game/$gameId'
      path: '/game/$gameId'
      fullPath: '/game/$gameId'
      preLoaderRoute: typeof AppGameGameIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile/history': {
      id: '/_app/profile/history'
      path: '/profile/history'
      fullPath: '/profile/history'
      preLoaderRoute: typeof AppProfileHistoryRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppplayFriendRoute: typeof AppplayFriendRoute
  AppplayQuickRoute: typeof AppplayQuickRoute
  AppGameGameIdRoute: typeof AppGameGameIdRoute
  AppProfileHistoryRoute: typeof AppProfileHistoryRoute
  ApphomeIndexRoute: typeof ApphomeIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppplayFriendRoute: AppplayFriendRoute,
  AppplayQuickRoute: AppplayQuickRoute,
  AppGameGameIdRoute: AppGameGameIdRoute,
  AppProfileHistoryRoute: AppProfileHistoryRoute,
  ApphomeIndexRoute: ApphomeIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
